import React from 'react';

const WidgetContent = ({ loading, showEditor, isVisualization, ragResult, chartHTML, onContentChange, id, title }) => {
  if (loading) {
    return (
      <div className="animate-pulse space-y-2">
        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
        <div className="h-4 bg-gray-200 rounded"></div>
        <div className="h-4 bg-gray-200 rounded w-5/6"></div>
        <div className="h-4 bg-gray-200 rounded w-2/3"></div>
      </div>
    );
  }

  if (showEditor && !isVisualization) {
    return (
      <textarea
        value={ragResult || ""}
        onChange={(e) => {
          if (typeof onContentChange === "function") {
            onContentChange(id, e.target.value);
          }
        }}
        rows={5}
        className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500/30"
      />
    );
  }

  if (isVisualization && chartHTML) {
    return (
      <div className="h-[300px] border border-gray-200 rounded-lg overflow-hidden">
        <iframe
          src={chartHTML}
          title={title}
          className="w-full h-full border-none"
        />
      </div>
    );
  }

  return (
    <div 
      className="prose prose-sm max-w-none text-gray-700"
      dangerouslySetInnerHTML={{ __html: ragResult || "" }}
    />
  );
};

export default WidgetContent;